import { z } from "zod";
import { zfd } from "zod-form-data";

export const phoneVerificationSchema = zfd.formData({
  phoneNumber: zfd.text(
    z
      .string()
      .refine((val) => /^\d{10,15}$/.test(val), {
        message: "*Veuillez entrer un numéro de téléphone valide.",
      })
      .optional(),
  ),
  verificationCode: zfd.text(
    z
      .string({
        invalid_type_error: "*Information non valide",
        required_error: "*Ce champ est requis.",
      })
      .length(6, "*Le code de vérification doit être de 6 chiffres.")
      .regex(
        /^\d{6}$/,
        "*Le code de vérification doit contenir uniquement des chiffres.",
      )
      .optional(),
  ),
});
